import {
  init as initSelects
} from '../../commons/select';

let backInStockInvite;
let backInStock;
let bisEmailInput;
let bisSMSInput;
let bisErrorZone;
let bisConfirmationEmail;
let captchaBlock;

const bisActiveClass = 'stock-notification__invite--active';
const isEmail = 'email';
const isSms = 'sms';
const bisloadingClass = 'stock-notification--loading';
const bisCompletedClass = 'stock-notification--completed';
const bisErrorClass = 'stock-notification--error';
const bisCaptchaErrClass = 'has-error';
const decat = window.decathlon;
const serviceParams = {};

let notificationType = isEmail;
let grecaptchaExecuted = false;

export const init = () => {
  backInStockInvite = cube.$('.stock-notification__invite');
  backInStock = cube.$('.stock-notification');

  bisEmailInput = cube.$id('back-in-stock-email');
  bisSMSInput = cube.$id('back-in-stock-sms');
  bisErrorZone = cube.$('.stock-notification__error');
  bisConfirmationEmail = cube.$('.stock-notification__confirmation-email');
  captchaBlock = cube.$id('bisCaptcha');
  const bisRadioButtons = cube.$$('.bis-radio');
  const bisTextInputs = cube.$$('.bis-input');
  const captchaFeatureEnabled = !!captchaBlock;
  const modalTogglerInput = cube.$id('stock-notification-modal__chk');
  const bisHolder = cube.$('.stock-notification__holder');

  // UPDATE VISUAL AFTER MODEL CHANGE IN BACK-IN-STOCK MODAL
  cube.event.on('modelChanged', newModelId => {
    const pictureToChange = backInStock.$('.stock-notification__product-picture');
    const newModelPicture = cube.$(`.media-zoom__thumbnails--alt[data-model-id="${ newModelId }"] picture`);

    if (pictureToChange && newModelPicture) {
      const JPEG = newModelPicture.$('source[type="image/jpeg"]').getAttribute('srcset');
      const WEBP = newModelPicture.$('source[type="image/webp"]').getAttribute('srcset');

      if (WEBP) {
        pictureToChange.$('source[type="image/webp"]').setAttribute('srcset', WEBP);
      }

      if (JPEG) {
        pictureToChange.$('source[type="image/jpeg"]').setAttribute('srcset', JPEG);
        pictureToChange.$('noscript').innerHTML = `<img src="${ JPEG }"`;
      }
    }
  });


  if (cube.$id('back-in-stock-form')) {
    initSelects();

    cube.$id('back-in-stock-form').addEventListener('submit', e => {
      e.preventDefault();
      toggleBisLoadingStatus(true);

      if (captchaFeatureEnabled) {
        cube.lazyLoadCaptcha();

        const executeCaptcha = () => {
          window.grecaptcha.execute();
          grecaptchaExecuted = true;
        };

        if (decat.captcha) {
          executeCaptcha();
        } else {
          cube.event.on('captcha-loaded', () => {
            executeCaptcha();
          });
        }
      } else {
        backInStockEmailOrSMSSubmit(notificationType);
      }
    });
  }

  if (bisRadioButtons.length > 0) {
    bisRadioButtons.on('change', event => {
      [...bisTextInputs].find(elt => elt.disabled === false).disabled = true;
      if (event.target.id === 'email-bis-radio') {
        bisHolder.classList.remove('stock-notification__holder--mobile');
        bisHolder.classList.add('stock-notification__holder--email');
        bisEmailInput.disabled = false;
        notificationType = isEmail;
        // if (cube.ui.isMobile()) {
        //   bisSMSInput.classList.add('vh');
        //   if (bisEmailInput.classList.contains('vh')) {
        //     bisEmailInput.classList.remove('vh');
        //   }
        // }
      } else {
        bisHolder.classList.remove('stock-notification__holder--email');
        bisHolder.classList.add('stock-notification__holder--mobile');
        bisSMSInput.disabled = false;
        notificationType = isSms;
        // if (cube.ui.isMobile()) {
        //   bisEmailInput.classList.add('vh');
        //   if (bisEmailInput.classList.contains('vh')) {
        //     bisSMSInput.classList.remove('vh');
        //   }
        // }
      }
    });
  }


  // Handle consent checkbox if feature is enabled
  if (cube.$id('stock-notification__consent')) {
    cube.$id('stock-notification__consent').addEventListener('change', () => {
      if (cube.$id('stock-notification__consent').checked) {
        serviceParams.hasConsent = true;
        cube.$id('back-in-stock-submit').disabled = false;
      } else {
        serviceParams.hasConsent = null;
        cube.$id('back-in-stock-submit').disabled = true;
      }
    });
  } else {
    serviceParams.hasConsent = null;
  }

  modalTogglerInput.addEventListener('change', updateModalDisplay);
};

const updateModalDisplay = (e) => {
  if (e.target.checked) {

    if (cube.$('#conversion-zone .sizes__size--selected').dataset.displayname) {
      const displayName = cube.$('#conversion-zone .sizes__size--selected').dataset.displayname;
      cube.$('.stock-notification__entry-title').innerHTML = window.Messages('pdm.backInStockNotif.modal.invitetitle', displayName);
    }
    const imgUrl = cube.$('.product-picture__slider .product-picture__slide:not(.fw-slider__clone)').$('img').currentSrc;
    if (imgUrl.length) {
      cube.$('.stock-notification__product-picture').src = imgUrl;
    }

    cube.$id('main-container').style.zIndex = 'inherit';

  } else {
    cube.$id('main-container').style.zIndex = null;
  }


};

export const showStockNotificationInvite = () => {

  backInStockInvite.classList.add(bisActiveClass);
  backInStock.classList.remove(bisCompletedClass);
  backInStock.classList.remove(bisErrorClass);

  if (cube.$('.stock-infos__message')) {
    cube.$('.stock-infos__message').classList.add('stock-infos__message--not-needed');
  }

  resetCaptcha();
  if (bisEmailInput !== null && bisSMSInput !== null) {
    toggleBisLoadingStatus(false);
  }
};

export const resetError = () => {
  if (backInStock.classList.contains(bisErrorClass)) {
    backInStock.classList.remove(bisErrorClass);
  }
};

export const hideStockNotificationInvite = () => {
  backInStockInvite.classList.remove(bisActiveClass);

  if (cube.$('.stock-infos__message')) {
    cube.$('.stock-infos__message').classList.remove('stock-infos__message--not-needed');
  }
};

function toggleBisLoadingStatus(status) {
  if (status) {
    backInStock.classList.add(bisloadingClass);
    bisEmailInput.disabled = true;
    if (notificationType === isSms) {
      bisSMSInput.disabled = true;
    }
  } else {
    backInStock.classList.remove(bisloadingClass);
    bisEmailInput.disabled = false;
    if (notificationType === isSms) {
      bisSMSInput.disabled = false;
    }
  }
}

function backInStockEmailOrSMSSubmit() {
  let isCaptchaValid = false;
  if (decat.captcha) {
    isCaptchaValid = decat.captcha.isCaptchaChecked;
  }
  const emailSizeLimit = bisEmailInput.getAttribute('maxlength') || 250;
  const smsSizeLimit = bisSMSInput ? bisSMSInput.getAttribute('maxlength') || 15 : 0;
  const bisEmail = bisEmailInput.value.match(cube.constants.regexEmail) ? bisEmailInput.value : '';
  let bisSMS = '';
  let safeBisEmail = '';
  let safeBisSMS = '';

  if (notificationType === isEmail) {
    safeBisEmail = bisEmail.substring(0, emailSizeLimit);
  } else {
    if (bisSMSInput.dataset.regex) {
      const isValid = new RegExp(bisSMSInput.dataset.regex, 'g')
        .test(bisSMSInput.value);
      if (isValid) {
        bisSMS = bisSMSInput.value;
      } else {
        bisSMS = '';
      }
    }
    safeBisSMS = bisSMS.substring(0, smsSizeLimit);
  }
  const selectedSku = cube.$('#conversion-zone .sizes__size--selected');
  const bisSkuId = selectedSku.dataset.id;
  const bisLocale = selectedSku.dataset.locale;
  const bisRegistrationUrl = 'rest/model/com/decathlon/cube/commerce/catalog/api/ProductNotifActor/registerSKUForBackInStockNotification';
  const alreadyRegisteredEmailErrorKey = 'ERROR_TEXT_ERROR_EMAIL_AND_SKU_REGISTERED';
  const missingChannelTypeErrorKey = 'ERROR_TEXT_MISSING_CHANNEL_TYPE';
  const missingSMSErrorKey = 'ERROR_TEXT_MISSING_SMS_ID';
  const duration = cube.$('.stock-notification .dkt-select__option--selected') ? parseInt(cube.$('.stock-notification .dkt-select__option--selected').value, 10) : null;
  const displayError = (message) => {
    backInStock.classList.add(bisErrorClass);
    bisErrorZone.innerHTML = message;
  };

  const ajaxSucces = (response) => {
    toggleBisLoadingStatus(false);

    if (response.responseTO == null || response.responseTO.messages.length) {
      if (notificationType === isEmail) {
        bisConfirmationEmail.innerHTML = bisEmail;
      } else {
        bisConfirmationEmail.innerHTML = bisSMS;
      }
      backInStock.classList.add(bisCompletedClass);
      backInStock.classList.remove(bisErrorClass);

    } else {
      const errorMessage = response.responseTO.errors[0].message;
      if (errorMessage === alreadyRegisteredEmailErrorKey) {
        displayError(window.Messages('pdm.backInStockNotification.alreadyRegisteredError'));
      } else if (errorMessage === missingChannelTypeErrorKey) {
        displayError(window.Messages('pdm.backInStockNotification.missingChannelType'));
      } else if (errorMessage === missingSMSErrorKey) {
        displayError(window.Messages('pdm.backInStockNotification.missingSMS'));
      } else {
        displayError(window.Messages('pdm.backInStockNotification.generalError'));
      }
    }

  };

  const ajaxError = () => {
    toggleBisLoadingStatus(false);
    displayError(window.Messages('pdm.backInStockNotification.generalError'));
  };

  resetError();

  serviceParams.skuId = bisSkuId;
  if (notificationType === isEmail) {
    serviceParams.channel = safeBisEmail;
    serviceParams.locale = bisLocale;
    serviceParams.channelType = isEmail;
  } else if (notificationType === isSms) {
    serviceParams.channel = safeBisSMS;
    serviceParams.locale = bisLocale;
    serviceParams.channelType = isSms;
  }
  if (duration) {
    serviceParams.expirationDelayWeek = duration;
  }

  if (!backInStock.classList.contains(bisCompletedClass)) {

    if (bisSkuId && (bisEmail.length > 0 || bisSMS.length > 0)) {
      cube.ajax
        .post(bisRegistrationUrl, serviceParams)
        .onSuccess(ajaxSucces)
        .onError(ajaxError)
        .call();
    } else if (decat.captcha && !isCaptchaValid && captchaBlock) {
      captchaBlock.classList.add(bisCaptchaErrClass);
    } else if (!bisSkuId && (bisEmail.length > 0 || bisSMS.length > 0)) {
      displayError(window.Messages('pdm.backInStockNotification.generalError'));
      toggleBisLoadingStatus(false);
    } else if (bisEmail.length === 0 && notificationType === isEmail) {
      displayError(window.Messages('pdm.backInStockNotification.emailError'));
      toggleBisLoadingStatus(false);
    } else if (bisSMS.length === 0 && notificationType === isSms) {
      displayError(window.Messages('pdm.backInStockNotification.smsError'));
      toggleBisLoadingStatus(false);
    }
  }
  bisEmailInput.addEventListener('input', resetError);
  if (bisSMSInput !== null) {
    bisSMSInput.addEventListener('input', resetError);
  }
  resetCaptcha();
  cube.$('.stock-notification--loading').classList.remove('stock-notification--loading');
};

function resetCaptcha() {
  if (decat.captcha && grecaptchaExecuted) {
    window.grecaptcha.reset();
    captchaBlock.classList.remove(bisCaptchaErrClass);
  }
};

window.setBISCaptchaChecked = (responseToken) => {
  decat.captcha.isCaptchaChecked = true;

  serviceParams[decat.captcha.responseTag] = responseToken;
  serviceParams[decat.captcha.isCaptchaInvisibleTag] = decat.captcha.isCaptchaInvisible;

  backInStockEmailOrSMSSubmit();
};

window.setBISCaptchaUnchecked = () => {
  decat.captcha.isCaptchaChecked = false;
};



// WEBPACK FOOTER //
// ./src/catalog/product-details/stock-notification.js